import { useEffect, useState } from "react";

/**
 * Tracks which section is currently in view based on an array of ids.
 *
 * Returns the id of the topmost section whose top has crossed an offset
 * line beneath the sticky header. Falls back to the first id when nothing
 * has crossed yet.
 */
export default function useScrollSpy(ids, { offset = 140 } = {}) {
  const [active, setActive] = useState(ids[0] || null);

  useEffect(() => {
    if (!ids || ids.length === 0) return undefined;

    let raf = 0;
    const compute = () => {
      raf = 0;
      const y = window.scrollY + offset + 1;
      let current = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top + window.scrollY;
        if (top <= y) current = id;
      }
      setActive((prev) => (prev === current ? prev : current));
    };

    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(compute);
    };

    compute();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [ids, offset]);

  return active;
}
